import { makeStyles } from "@material-ui/core";
import React, { useCallback } from "react";
import Select from "react-select";
import { ValueType } from "react-select/src/types";

function getLabelByBoolean(isInactive: boolean): string {
    return isInactive ? "Deactivated" : "Active";
}

const AVAILABLE_OPTIONS = [
    { value: false, label: getLabelByBoolean(false) },
    { value: true, label: getLabelByBoolean(true) },
];

interface Props {
    isInactive: boolean | undefined;
    setValue: (value: boolean | undefined) => void;
}

export function EmployeeStatusSelect({
    isInactive,
    setValue,
}: Props) {
    const classes = useStyles();

    const handleChange = useCallback((selectedValue: ValueType<{ value: boolean; label: string; }>) => {
        const typedSelectedValue = selectedValue as { value: boolean; label: string; } | null;
        if (!typedSelectedValue) {
            setValue(undefined)
            return;
        };
        setValue(typedSelectedValue.value);
    }, [setValue]);

    return (
        <div className={classes.container}>
            <label htmlFor="employee-status-select">Status:</label>
            <Select
                inputId="employee-status-select"
                options={AVAILABLE_OPTIONS}
                value={isInactive !== undefined
                    ? { value: isInactive, label: getLabelByBoolean(isInactive) }
                    : null
                }
                noOptionsMessage={() => "Select..."}
                onChange={handleChange}
                isClearable={true}
                isSearchable={false}
                styles={{
                    container: base => ({ ...base, width: 280 }),
                }}
            />
        </div>
    );
}

const useStyles = makeStyles({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        marginTop: "20px",
        marginBottom: "10px",
        maxWidth: "400px",
    },
});